import Ajv from 'ajv';

export class JsonSchemaValidatorHelper {
  static isSchemaValid(schema: Record<string, any>): boolean {
    const ajv = new Ajv();
    const isValid = ajv.validateSchema(schema) as boolean;
    return isValid;
  }

  static validateData(schema: Record<string, any>, data: any) {
    const ajv = new Ajv();
    const validator = ajv.compile(schema);
    return validator(data);
  }
}
